export default __webpack_public_path__ + "static/vision5-afecece26dfff2fb40b4bc5a756b0247.png";